import { State } from "../../types";

export type MarkCellActiveAction = Readonly<{
  cellId: string;
  type: "MARK CELL ACTIVE";
}>;

export const markCellActive = (state: State, action: MarkCellActiveAction): State => {
  return {
    ...state,
    selectedCellId: action.cellId,
  };
};
